import { c as _c } from "react/compiler-runtime";
import Add from "@mui/icons-material/Add";
import Edit from "@mui/icons-material/Edit";
import FolderOpen from "@mui/icons-material/FolderOpen";
import { TabContext, TabList } from "@mui/lab";
import { IconButton, Stack, Tab, Tooltip } from "@mui/material";
import Head from "next/head";
import React, { useState } from "react";
import { ArgsEditor } from "#/features/argsEditor/ui/ArgsEditor";
import { useProjectPanelData } from "#/features/project/hooks/useProjectPanelData";
import { useProjectBrowserContext } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContext";
import { TestCaseSelectBar } from "#/features/project/ui/TestCaseSelectBar";
import { useI18nContext } from "#/shared/hooks";
import { LoadingSkeletonOverlay } from "#/shared/ui/atoms/LoadingSkeletonOverlay";
import { PanelWrapper } from "#/shared/ui/templates/PanelWrapper";
import { StyledTabPanel } from "#/shared/ui/templates/StyledTabPanel";
import { TabListWrapper } from "#/shared/ui/templates/TabListWrapper";
import { ProjectInfo } from "./ProjectInfo";
import { ProjectModal } from "./ProjectModal";
export const ProjectPanel: React.FC = () => {
  const $ = _c(60);
  const {
    LL
  } = useI18nContext();
  const {
    session,
    isEditable,
    selectedProject,
    selectedCase
  } = useProjectPanelData();
  const {
    openBrowser
  } = useProjectBrowserContext();
  const [tabValue, setTabValue] = useState("1");
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isModalEditMode, setIsModalEditMode] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (_, newValue) => {
      setTabValue(newValue);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleTabChange = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalEditMode(false);
      setIsProjectModalOpen(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCreateProject = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalEditMode(true);
      setIsProjectModalOpen(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleEditProject = t2;
  const t3 = selectedProject.data ? `${selectedProject.data?.title} - dStruct Playground` : "dStruct Playground";
  let t4;
  if ($[3] !== t3) {
    t4 = <Head><title>{t3}</title></Head>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsProjectModalOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isModalEditMode || $[7] !== isProjectModalOpen || $[8] !== selectedProject.data) {
    t6 = <ProjectModal open={isProjectModalOpen} onClose={t5} isEditMode={isModalEditMode} currentProject={selectedProject.data} />;
    $[6] = isModalEditMode;
    $[7] = isProjectModalOpen;
    $[8] = selectedProject.data;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LoadingSkeletonOverlay />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== LL) {
    t8 = LL.PANEL_TABS();
    $[11] = LL;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== LL) {
    t9 = LL.PROJECT();
    $[13] = LL;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <Tab label={t9} value="1" />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <TabList onChange={handleTabChange} aria-label={t8}>{t10}</TabList>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== LL) {
    t12 = LL.PROJECT_BROWSER();
    $[20] = LL;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = `${t12} 📁`;
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FolderOpen />;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== openBrowser) {
    t15 = <IconButton onClick={openBrowser}>{t14}</IconButton>;
    $[23] = openBrowser;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <Tooltip title={t13} arrow={true}>{t15}</Tooltip>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== LL || $[29] !== isEditable) {
    t17 = isEditable && <Tooltip title={`${LL.EDIT_SELECTED_PROJECT()} ✍`} arrow={true}><IconButton onClick={handleEditProject}><Edit /></IconButton></Tooltip>;
    $[28] = LL;
    $[29] = isEditable;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== LL || $[32] !== session.data) {
    t18 = session.data && <Tooltip title={`${LL.CREATE_NEW_PROJECT()} ➕`} arrow={true}><IconButton onClick={handleCreateProject}><Add /></IconButton></Tooltip>;
    $[31] = LL;
    $[32] = session.data;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t18) {
    t19 = <Stack direction="row" spacing={1} alignItems="center" pr={1}>{t16}{t17}{t18}</Stack>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t11 || $[39] !== t19) {
    t20 = <TabListWrapper>{t11}{t19}</TabListWrapper>;
    $[38] = t11;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      display: "flex",
      flexFlow: "column nowrap",
      p: 2,
      gap: 1
    };
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== selectedProject.data) {
    t22 = <ProjectInfo project={selectedProject.data} />;
    $[42] = selectedProject.data;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== selectedProject) {
    t23 = <TestCaseSelectBar selectedProject={selectedProject} />;
    $[44] = selectedProject;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== selectedCase) {
    t24 = <ArgsEditor selectedCase={selectedCase} />;
    $[46] = selectedCase;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t22 || $[49] !== t23 || $[50] !== t24) {
    t25 = <StyledTabPanel value="1" sx={t21}>{t22}{t23}{t24}</StyledTabPanel>;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t20 || $[53] !== t25 || $[54] !== tabValue) {
    t26 = <TabContext value={tabValue}>{t20}{t25}</TabContext>;
    $[52] = t20;
    $[53] = t25;
    $[54] = tabValue;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t26 || $[57] !== t4 || $[58] !== t6) {
    t27 = <PanelWrapper>{t4}{t6}{t7}{t26}</PanelWrapper>;
    $[56] = t26;
    $[57] = t4;
    $[58] = t6;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
};